import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class ServoMotorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'servoMotor',
            name: 'Servo',
            color1: '#0097A7',
            color2: '#00838F',
            color3: '#006064',

            blocks: [
                {
                    opcode: 'servo_setAngle',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'servoMotor.blocks.setAngle',
                        default: 'set servo on pin [PIN] to [ANGLE] °'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '9',
                            menu: 'digitalPinMenu'
                        },
                        ANGLE: {
                            type: 'number',
                            defaultValue: '90'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'servo_setAngle',
                    type: 'command',
                    arduino: {
                        code: 'servo_{{PIN}}.write({{ANGLE}});',
                        setup: ['servo_{{PIN}}.attach({{PIN}});'],
                        includes: ['#include <Servo.h>']
                    },
                    python: {
                        code: 'servo_{{PIN}}.duty_u16(int(4000 + ({{ANGLE}} / 180.0) * 4000))', // Simple MicroPython mapping
                        setup: [
                            'servo_{{PIN}} = PWM(Pin({{PIN}}))',
                            'servo_{{PIN}}.freq(50)'
                        ],
                        imports: ['from machine import Pin, PWM']
                    }
                }
            ]
        };
    }

    servo_setAngle (args) {
        return Promise.resolve(); // Simulate instantly resolving
    }
}

export default ServoMotorExtension;
